/* eslint-disable */
import $ from 'jquery'
var wxParam = {};
var wx_share = function (param) {
    $.ajax({
        url: 'https://xinli.jiemengjia.com/p/order/wxPayJsConfig',
        type: "POST",
        data: {
            link: location.href,
            version_id: '1.6',
        },
        success: function (res) {
            if (res.rt == '0000') {
                var data = res.data;
                wxParam = param;

                // 分享配置
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，企业号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名，见附录1
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
            }
        },
        error: function (res) {}
    })
}

wx_share({
    title: "我邀请你：测测你的海洋生物性格~",
    desc: "揭秘你的真实内在",
    link: "https://active.zxdance.com/seaTest/index.html",
    imgUrl: 'https://xd-dolphin.oss-cn-beijing.aliyuncs.com/dolphin-python-psy-1628651547-GLX6c.png',
    type: 'link', //分享类型,music、 video或link， 不填默认为link,
    dataUrl: '', //如果type是music或video， 则要提供数据链接， 默认为空,
    successFn: function () {
        // 用户确认分享后执行的回调函数
    },
    cancelFn: function () {
        // 用户取消分享后执行的回调函数
    }
});

wx.ready(function () {
    //分享到朋友圈
    wx.onMenuShareTimeline({
        title: wxParam.title,
        link: wxParam.link,
        imgUrl: wxParam.imgUrl,
        success: function () {
            if (wxParam.successFn) {
                wxParam.successFn();
            }
        },
        cancel: function () {
            if (wxParam.cancelFn) {
                wxParam.cancelFn();
            }
        }
    });

    //分享给朋友
    wx.onMenuShareAppMessage({
        title: wxParam.title,
        desc: wxParam.desc,
        link: wxParam.link,
        imgUrl: wxParam.imgUrl,
        type: wxParam.type,
        dataUrl: wxParam.dataUrl,
        success: function () {
            if (wxParam.successFn) {
                wxParam.successFn();
            }
        },
        cancel: function () {
            if (wxParam.cancelFn) {
                wxParam.cancelFn();
            }
        }
    });

    //分享到QQ
    wx.onMenuShareQQ({
        title: wxParam.title,
        desc: wxParam.desc,
        link: wxParam.link,
        imgUrl: wxParam.imgUrl,
        success: function () {
            if (wxParam.successFn) {
                wxParam.successFn();
            }
        },
        cancel: function () {
            if (wxParam.cancelFn) {
                wxParam.cancelFn();
            }
        }
    });

    //分享到腾讯微博
    wx.onMenuShareWeibo({
        title: wxParam.title,
        desc: wxParam.desc,
        link: wxParam.link,
        imgUrl: wxParam.imgUrl,
        success: function () {
            if (wxParam.successFn) {
                wxParam.successFn();
            }
        },
        cancel: function () {
            if (wxParam.cancelFn) {
                wxParam.cancelFn();
            }
        }
    });

    //分享到QQ空间
    wx.onMenuShareQZone({
        title: wxParam.title,
        desc: wxParam.desc,
        link: wxParam.link,
        imgUrl: wxParam.imgUrl,
        success: function () {
            if (wxParam.successFn) {
                wxParam.successFn();
            }
        },
        cancel: function () {
            if (wxParam.cancelFn) {
                wxParam.cancelFn();
            }
        }
    });
})